import { TableCell } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledRowTableCell = styled(TableCell)(({ theme }) => ({
  color: 'black',
  fontSize: '15px',
  textAlign: 'center',
}));

const RowTableCell = ({ 
  children, 
  wxs, 
  wmd, 
  wlg,
  wxl,
  fontxs,
  fontmd,
  fontlg,
  fontxl,
  padxs,
  padmd,
  padlg,
  padxl,
  displayxs,
  displaymd,
  displaylg,
  displayxl,
  sx = {}, 
  ...props 
}) => {
  const responsiveStyles = {};
  
  // Width styles
  if (wxs || wmd || wlg || wxl) {
    responsiveStyles.width = {};
    if (wxs) responsiveStyles.width.xs = wxs;
    if (wmd) responsiveStyles.width.md = wmd;
    if (wlg) responsiveStyles.width.lg = wlg;
    if (wxl) responsiveStyles.width.xl = wxl;
  }

  // Font size styles
  if (fontxs || fontmd || fontlg || fontxl) {
    responsiveStyles.fontSize = {};
    if (fontxs) responsiveStyles.fontSize.xs = fontxs;
    if (fontmd) responsiveStyles.fontSize.md = fontmd;
    if (fontlg) responsiveStyles.fontSize.lg = fontlg;
    if (fontxl) responsiveStyles.fontSize.xl = fontxl;
  }

  // Padding styles
  if (padxs || padmd || padlg || padxl) {
    responsiveStyles.padding = {};
    if (padxs) responsiveStyles.padding.xs = padxs;
    if (padmd) responsiveStyles.padding.md = padmd;
    if (padlg) responsiveStyles.padding.lg = padlg;
    if (padxl) responsiveStyles.padding.xl = padxl;
  }

  // Display styles
  if (displayxs || displaymd || displaylg || displayxl) {
    responsiveStyles.display = {};
    if (displayxs) responsiveStyles.display.xs = displayxs;
    if (displaymd) responsiveStyles.display.md = displaymd;
    if (displaylg) responsiveStyles.display.lg = displaylg;
    if (displayxl) responsiveStyles.display.xl = displayxl;
  }

  const combinedSx = {
    ...responsiveStyles,
    ...sx,
  };

  return (
    <StyledRowTableCell sx={combinedSx} {...props}>
      {children}
    </StyledRowTableCell>
  );
};

export default RowTableCell;